export enum ResourceCategories {
  Education_Testing = 100,
  Employment_Requirements = 200,
  Benefits = 300,
  Payroll = 400,
  Housing_Travel = 500,
  Event_Resources = 600,
}
